import { ElementRef } from "@angular/core";
import { Calendar } from "@fullcalendar/core";
import { CoachSlot } from '../../shared/model/coach-slot.model';
import { PasswordResetInitService } from '../../account/password-reset/init/password-reset-init.service';
import { FormBuilder, FormControl } from "@angular/forms";
import { LoginService } from '../../core/login/login.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AccountService } from '../../core/auth/account.service';
import { JhiLanguageService } from '../../ng-jhipster/language';
import { JhiEventManager } from '../../ng-jhipster/service';
import { AlertModalComponent } from '../../shared/alert/alert-modal.component';
import { UserService } from '../../core/user/user.service';
import { CoachSlotService } from '../slot/coach-slot.service';
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import allLocales from "@fullcalendar/core/locales-all";
import moment from "moment";
import { debug, NEW_CLIENTS_INTERVALS, TIMEZONES } from '../../app.constants';
import { CoachDetailsService } from '../slot/coach-details.service';
import { PlanYourCapacityComponent } from '../my-availability/plan-your-capacity.component';
import { CoachAvailabilityPreference } from '../../shared/model/admin/coach-availability-preference.model';
import { CoachAvailabilityPreferenceService } from '../admin/coach-availability-preference/coach-availability-preference.service';
import { User } from '../../core/user/user.model';
import * as i0 from "@angular/core";
import * as i1 from "../../core/user/user.service";
import * as i2 from "../slot/coach-slot.service";
import * as i3 from "../slot/coach-details.service";
import * as i4 from "../../ng-jhipster/language";
import * as i5 from "../../account/password-reset/init/password-reset-init.service";
import * as i6 from "@angular/forms";
import * as i7 from "../../core/login/login.service";
import * as i8 from "@ng-bootstrap/ng-bootstrap";
import * as i9 from "../../core/auth/account.service";
import * as i10 from "../../ng-jhipster/service";
import * as i11 from "../admin/coach-availability-preference/coach-availability-preference.service";
import * as i12 from "../../ng-jhipster/language/jhi-translate.directive";
import * as i13 from "@angular/material/form-field";
import * as i14 from "@angular/material/input";
import * as i15 from "@angular/material/select";
import * as i16 from "@angular/common";
import * as i17 from "@angular/material/datepicker";
import * as i18 from "@angular/material/core";
import * as i19 from "@fullcalendar/angular";
import * as i20 from "@angular-material-components/datetime-picker";
import * as i21 from "@ngx-translate/core";
const _c0 = ["fullCalendarComponent"];
const _c1 = ["eventModal"];
const _c2 = ["limitModal"];
function MyAvailabilityComponent_mat_option_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵelement(1, "span", 36);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const nci_r8 = ctx.$implicit;
    i0.ɵɵproperty("value", nci_r8);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "settings.acceptNewClientIntervals.", nci_r8, "");
} }
function MyAvailabilityComponent_div_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 37);
    i0.ɵɵelement(2, "full-calendar", 38);
    i0.ɵɵelement(3, "full-calendar", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("options", ctx_r3.webCalendarOptions);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("options", ctx_r3.mobileCalendarOptions);
} }
function MyAvailabilityComponent_ng_template_43_mat_option_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r17 = ctx.$implicit;
    i0.ɵɵproperty("value", type_r17);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(type_r17);
} }
function MyAvailabilityComponent_ng_template_43_div_12_mat_option_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const type_r19 = ctx.$implicit;
    i0.ɵɵproperty("value", type_r19);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(type_r19);
} }
function MyAvailabilityComponent_ng_template_43_div_12_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵelementStart(2, "label", 59);
    i0.ɵɵtext(3, "Session type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-form-field");
    i0.ɵɵelementStart(5, "mat-label", 60);
    i0.ɵɵtext(6, "Select a session type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-select", 61);
    i0.ɵɵlistener("valueChange", function MyAvailabilityComponent_ng_template_43_div_12_Template_mat_select_valueChange_7_listener($event) { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.event.availableSessionType = $event; });
    i0.ɵɵtemplate(8, MyAvailabilityComponent_ng_template_43_div_12_mat_option_8_Template, 2, 2, "mat-option", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("value", ctx_r11.event.availableSessionType);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r11.availableSessionTypes);
} }
function MyAvailabilityComponent_ng_template_43_div_36_mat_option_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 35);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const recurrence_r23 = ctx.$implicit;
    i0.ɵɵproperty("value", recurrence_r23);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(recurrence_r23);
} }
function MyAvailabilityComponent_ng_template_43_div_36_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 43);
    i0.ɵɵelementStart(1, "div", 44);
    i0.ɵɵelementStart(2, "label", 62);
    i0.ɵɵtext(3, "Recurrence");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-form-field");
    i0.ɵɵelementStart(5, "mat-label", 63);
    i0.ɵɵtext(6, "Select a recurrence");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-select", 64);
    i0.ɵɵlistener("valueChange", function MyAvailabilityComponent_ng_template_43_div_36_Template_mat_select_valueChange_7_listener($event) { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(2); return ctx_r24.event.recurrence = $event; });
    i0.ɵɵtemplate(8, MyAvailabilityComponent_ng_template_43_div_36_mat_option_8_Template, 2, 2, "mat-option", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("value", ctx_r15.event.recurrence);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r15.recurrences);
} }
function MyAvailabilityComponent_ng_template_43_button_39_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 65);
    i0.ɵɵlistener("click", function MyAvailabilityComponent_ng_template_43_button_39_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.deleteEvent(ctx_r26.event.id); });
    i0.ɵɵelementEnd();
} }
function MyAvailabilityComponent_ng_template_43_Template(rf, ctx) { if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "form", 41);
    i0.ɵɵlistener("ngSubmit", function MyAvailabilityComponent_ng_template_43_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r29); const ctx_r28 = i0.ɵɵnextContext(); return ctx_r28.onCalendarEventChange(); });
    i0.ɵɵelementStart(2, "div", 42);
    i0.ɵɵelementStart(3, "div", 43);
    i0.ɵɵelementStart(4, "div", 44);
    i0.ɵɵelementStart(5, "label", 45);
    i0.ɵɵtext(6, "Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-form-field");
    i0.ɵɵelementStart(8, "mat-label", 46);
    i0.ɵɵtext(9, "Select a type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "mat-select", 47);
    i0.ɵɵlistener("valueChange", function MyAvailabilityComponent_ng_template_43_Template_mat_select_valueChange_10_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r30 = i0.ɵɵnextContext(); return ctx_r30.event.type = $event; });
    i0.ɵɵtemplate(11, MyAvailabilityComponent_ng_template_43_mat_option_11_Template, 2, 2, "mat-option", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(12, MyAvailabilityComponent_ng_template_43_div_12_Template, 9, 2, "div", 48);
    i0.ɵɵelementStart(13, "div", 43);
    i0.ɵɵelementStart(14, "div", 44);
    i0.ɵɵelementStart(15, "label", 49);
    i0.ɵɵtext(16, "Start");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "mat-form-field");
    i0.ɵɵelementStart(18, "mat-label", 14);
    i0.ɵɵtext(19, "Select a start date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "input", 50, 51);
    i0.ɵɵlistener("dateInput", function MyAvailabilityComponent_ng_template_43_Template_input_dateInput_20_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r31 = i0.ɵɵnextContext(); return ctx_r31.onMatDateTimePickerChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(22, "mat-datepicker-toggle", 16);
    i0.ɵɵelementStart(23, "ngx-mat-datetime-picker", 52, 53);
    i0.ɵɵlistener("opened", function MyAvailabilityComponent_ng_template_43_Template_ngx_mat_datetime_picker_opened_23_listener() { i0.ɵɵrestoreView(_r29); const ctx_r32 = i0.ɵɵnextContext(); return ctx_r32.onMatDateTimePickerToggleClick(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 43);
    i0.ɵɵelementStart(26, "div", 44);
    i0.ɵɵelementStart(27, "label", 54);
    i0.ɵɵtext(28, "End");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "mat-form-field");
    i0.ɵɵelementStart(30, "mat-label", 19);
    i0.ɵɵtext(31, "Select an end date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "input", 55);
    i0.ɵɵlistener("dateInput", function MyAvailabilityComponent_ng_template_43_Template_input_dateInput_32_listener($event) { i0.ɵɵrestoreView(_r29); const ctx_r33 = i0.ɵɵnextContext(); return ctx_r33.onMatDateTimePickerChange($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "mat-datepicker-toggle", 16);
    i0.ɵɵelementStart(34, "ngx-mat-datetime-picker", 52, 56);
    i0.ɵɵlistener("opened", function MyAvailabilityComponent_ng_template_43_Template_ngx_mat_datetime_picker_opened_34_listener() { i0.ɵɵrestoreView(_r29); const ctx_r34 = i0.ɵɵnextContext(); return ctx_r34.onMatDateTimePickerToggleClick(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(36, MyAvailabilityComponent_ng_template_43_div_36_Template, 9, 2, "div", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(37, "div", 22);
    i0.ɵɵelementStart(38, "button", 57);
    i0.ɵɵlistener("click", function MyAvailabilityComponent_ng_template_43_Template_button_click_38_listener() { const restoredCtx = i0.ɵɵrestoreView(_r29); const eventModal_r9 = restoredCtx.$implicit; return eventModal_r9.close("modal closed"); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(39, MyAvailabilityComponent_ng_template_43_button_39_Template, 1, 0, "button", 58);
    i0.ɵɵelement(40, "button", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r13 = i0.ɵɵreference(24);
    const _r14 = i0.ɵɵreference(35);
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("value", ctx_r5.event.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.types);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.event.type === "available");
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("formControl", ctx_r5.startFormControl)("ngxMatDatetimePicker", _r13);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("for", _r13);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("stepMinute", 30);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("formControl", ctx_r5.endFormControl)("ngxMatDatetimePicker", _r14);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("for", _r14);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("stepMinute", 30);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r5.event.type === "available");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r5.event.id);
} }
function MyAvailabilityComponent_ng_template_45_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 65);
    i0.ɵɵlistener("click", function MyAvailabilityComponent_ng_template_45_button_13_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.deleteEvent(ctx_r38.event.id); });
    i0.ɵɵelementEnd();
} }
function MyAvailabilityComponent_ng_template_45_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵelementStart(1, "form", 41);
    i0.ɵɵlistener("ngSubmit", function MyAvailabilityComponent_ng_template_45_Template_form_ngSubmit_1_listener() { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.onDailySessionLimitChange(); });
    i0.ɵɵelementStart(2, "div", 42);
    i0.ɵɵelementStart(3, "div", 43);
    i0.ɵɵelementStart(4, "div", 44);
    i0.ɵɵelementStart(5, "label", 66);
    i0.ɵɵtext(6, "Daily session limit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "mat-form-field");
    i0.ɵɵelementStart(8, "mat-label", 67);
    i0.ɵɵtext(9, "Select a daily session limit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "input", 68);
    i0.ɵɵlistener("ngModelChange", function MyAvailabilityComponent_ng_template_45_Template_input_ngModelChange_10_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(); return ctx_r42.dailyLimit = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 22);
    i0.ɵɵelementStart(12, "button", 57);
    i0.ɵɵlistener("click", function MyAvailabilityComponent_ng_template_45_Template_button_click_12_listener() { const restoredCtx = i0.ɵɵrestoreView(_r41); const limitModal_r36 = restoredCtx.$implicit; return limitModal_r36.close("modal closed"); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(13, MyAvailabilityComponent_ng_template_45_button_13_Template, 1, 0, "button", 58);
    i0.ɵɵelement(14, "button", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("formControl", ctx_r7.limitValueFormControl)("ngModel", ctx_r7.dailyLimit);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r7.event.id);
} }
const SLOT_TYPES = ['available', 'vacation'];
const AVAILABLE_SESSION_TYPES = ['text', 'video', 'all'];
const RECURRENCE_TYPES = ['none', 'daily', 'weekly'];
export class MyAvailabilityComponent {
    constructor(userService, coachSlotService, coachDetailsService, languageService, passwordResetInitService, formBuilder, loginService, modalService, accountService, eventManager, coachAvailabilityPreferenceService) {
        this.userService = userService;
        this.coachSlotService = coachSlotService;
        this.coachDetailsService = coachDetailsService;
        this.languageService = languageService;
        this.passwordResetInitService = passwordResetInitService;
        this.formBuilder = formBuilder;
        this.loginService = loginService;
        this.modalService = modalService;
        this.accountService = accountService;
        this.eventManager = eventManager;
        this.coachAvailabilityPreferenceService = coachAvailabilityPreferenceService;
        this.thresholdWidth = 470;
        this.types = SLOT_TYPES;
        this.availableSessionTypes = AVAILABLE_SESSION_TYPES;
        this.recurrences = RECURRENCE_TYPES;
        this.calendar = new Calendar(this.fullCalendarComponent);
        this.eventList = [];
        this.onlyPositiveNumbers = new RegExp("^\\d*$");
        this.modalOptions = { windowClass: 'modal-window', size: 'md', centered: true };
        this.eventModalOptions = {
            size: "md",
            hideCloseButton: true,
            centered: true,
            backdrop: false,
            animation: true,
            keyboard: true,
            closeOnOutsideClick: false,
            windowClass: 'coach-slot-modal'
        };
        this.startDate = moment().startOf('week').add(1, 'day');
        this.endDate = moment().startOf('week').add(8, 'day');
        this.myAvailabilityPreference = new CoachAvailabilityPreference();
        this.availabilityPreferenceForm = this.formBuilder.group({
            id: [],
            newClientsNumber: [null],
            newClientsInterval: [null],
            chatSessionsPerWeek: [null],
            videoSessionsPerWeek: [null],
            additionalNotes: [null],
            frequencyLastUpdated: [null],
            capacityLastUpdated: [null],
            coach: [null],
        });
        this.newClientsInterval = NEW_CLIENTS_INTERVALS;
        this.frequencyStartDate = new FormControl(moment().toDate());
        this.frequencyEndDate = new FormControl(moment().add(3, "month").toDate());
        this.TIMEZONES = TIMEZONES;
    }
    ngOnInit() {
        this.windowWidth = document.documentElement.clientWidth;
        this.windowHeight = document.documentElement.clientHeight;
        this.responsiveTitleFormat = this.windowWidth < this.thresholdWidth
            ? { month: 'short', day: 'numeric' }
            : { year: 'numeric', month: 'short', day: 'numeric' };
        this.userService.getCurrentCoach().subscribe(response1 => {
            this.coach = response1;
            this.coachId = this.coach.coachId;
            this.coachDetailsService.findCoachDetails(this.coachId).subscribe(response2 => {
                this.coachDetails = response2.body;
            });
            this.renderCalendar(this.coachId);
            this.coachAvailabilityPreferenceService.findByCurrentCoach().subscribe(response3 => {
                console.log(response3);
                this.myAvailabilityPreference = response3.body;
                if (this.myAvailabilityPreference.startDate)
                    this.frequencyStartDate = new FormControl(this.myAvailabilityPreference.startDate.toDate());
                if (this.myAvailabilityPreference.endDate)
                    this.frequencyEndDate = new FormControl(this.myAvailabilityPreference.endDate.toDate());
            }, error => {
                console.log(error);
            });
        });
        this.eventManager.subscribe('langKeyChanged', () => this.renderCalendar(this.coachId));
    }
    renderCalendar(coachId) {
        this.coachSlotService.queryCoach(coachId).subscribe(res => {
            this.eventList = res.body;
            this.webCalendarOptions = {
                plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
                locales: allLocales,
                locale: this.languageService.getCurrentLanguage(),
                slotDuration: '00:30:00',
                initialView: 'timeGridWeek',
                firstDay: 1,
                allDaySlot: false,
                weekends: true,
                weekNumbers: true,
                navLinks: true,
                nowIndicator: true,
                selectable: true,
                selectMirror: true,
                unselectCancel: 'event-form',
                editable: true,
                eventColor: '#EAD88C',
                eventStartEditable: true,
                eventDurationEditable: true,
                eventResizableFromStart: true,
                eventOverlap: false,
                selectOverlap: false,
                dayMaxEventRows: true,
                dayHeaderFormat: this.handleDesktopDayHeaderFormat.bind(this),
                navLinkDayClick: this.handleDayHeaderClick.bind(this),
                moreLinkClick: 'timeGridWeek',
                headerToolbar: { left: 'title', right: 'today prev,next dayGridMonth,timeGridWeek,timeGridDay,listYear' },
                titleFormat: { year: 'numeric', month: 'short', day: 'numeric' },
                displayEventTime: false,
                eventContent: this.handleEventContent.bind(this),
                events: this.eventList.filter(item => item.type !== 'limit'),
                selectAllow: this.handleSelectAllow.bind(this),
                select: this.handleEventSelect.bind(this),
                eventClick: this.handleEventSelect.bind(this),
                eventDrop: this.handleEventChange.bind(this),
                eventConstraint: { startTime: '00:00', endTime: '24:00' },
                eventResize: this.handleEventChange.bind(this),
                contentHeight: this.windowHeight - 280
            };
            this.mobileCalendarOptions = {
                plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin],
                locales: allLocales,
                locale: this.languageService.getCurrentLanguage(),
                slotDuration: '00:30:00',
                initialView: 'timeGridDay',
                firstDay: 1,
                allDaySlot: false,
                weekends: true,
                weekNumbers: true,
                navLinks: true,
                nowIndicator: true,
                selectable: true,
                selectMirror: true,
                unselectCancel: 'event-form',
                editable: true,
                eventColor: '#EAD88C',
                eventStartEditable: true,
                eventDurationEditable: true,
                eventResizableFromStart: true,
                eventOverlap: false,
                selectOverlap: false,
                dayMaxEventRows: true,
                dayHeaderFormat: this.handleMobileDayHeaderFormat.bind(this),
                navLinkDayClick: this.handleDayHeaderClick.bind(this),
                moreLinkClick: 'timeGridDay',
                headerToolbar: { left: '', center: '', right: 'today prev,next timeGridDay,listYear' },
                titleFormat: { year: 'numeric', month: 'short', day: 'numeric' },
                views: { listYear: { titleFormat: { year: 'numeric' } } },
                displayEventTime: false,
                eventContent: this.handleEventContent.bind(this),
                events: this.eventList.filter(item => item.type !== 'limit'),
                select: this.handleEventSelect.bind(this),
                eventClick: this.handleEventSelect.bind(this),
                eventDrop: this.handleEventChange.bind(this),
                eventConstraint: { startTime: '00:00', endTime: '24:00' },
                eventResize: this.handleEventChange.bind(this),
                contentHeight: this.windowHeight - 280
            };
        });
    }
    handleEventContent(arg) {
        return {
            html: "<div class='fc-event-main-frame'>" +
                "<div class='fc-event-title-container'>" +
                "<div class='fc-event-title fc-sticky'>" + arg.event.title + "</div>" +
                "</div>" +
                "</div>"
        };
    }
    handleDesktopDayHeaderFormat(arg) {
        this.event = this.eventList.find(item => item.type === 'limit' && item.limitValue > -1 &&
            moment(item.startDateTime).format('YYYY-MM-DD') === moment(arg.date).format('YYYY-MM-DD'));
        return this.event ? (moment(arg.date).format('ddd Do') + ', Max: ' + this.event.limitValue) : (moment(arg.date).format('ddd Do'));
    }
    handleMobileDayHeaderFormat(arg) {
        this.event = this.eventList.find(item => item.type === 'limit' && item.limitValue > -1 &&
            moment(item.startDateTime).format('YYYY-MM-DD') === moment(arg.date).format('YYYY-MM-DD'));
        return this.event ? (moment(arg.date).format('MMM Do, ddd') + ', Max: ' + this.event.limitValue) : (moment(arg.date).format('MMM Do, ddd'));
    }
    handleDayHeaderClick(arg) {
        this.dailyLimit = null;
        this.updateCoachSlot(arg, 'limit');
        this.openLimitModal();
    }
    handleSelectAllow(arg) {
        return arg.start.getDay() === arg.end.getDay();
    }
    handleEventSelect(arg) {
        this.updateCoachSlot(arg, 'event');
        this.openEventModal();
    }
    handleEventChange(arg) {
        this.updateCoachSlot(arg, 'event');
        this.updateEvent();
    }
    updateCoachSlot(arg, type) {
        if (type === 'limit') { // Tue Nov 09 2021 00:00:00 GMT+0300 (GMT+03:00)
            let today = moment(arg);
            this.event = this.eventList.find(item => item.type === 'limit' && item.limitValue > -1 &&
                moment(item.startDateTime).format('YYYY-MM-DD') === today.format('YYYY-MM-DD'));
            this.event = this.event ? this.event : new CoachSlot();
            if (this.event.limitValue)
                this.dailyLimit = this.event.limitValue;
            this.event.startDateTime = today;
            this.event.endDateTime = today;
            this.event.type = 'limit';
            this.event.recurrence = 'none';
            this.limitValueFormControl = new FormControl(this.event.limitValue);
        }
        else if (type === 'event') {
            this.event = arg.event ? this.eventList.find(item => item.id === arg.event.id) : new CoachSlot();
            this.event.startDateTime = arg.event ? moment(arg.event.start) : moment(arg.start);
            this.event.endDateTime = arg.event ? moment(arg.event.end) : moment(arg.end);
            this.startFormControl = new FormControl(this.event.startDateTime.toDate());
            this.endFormControl = new FormControl(this.event.endDateTime.toDate());
            this.event.start = this.event.startDateTime.format('YYYY-MM-DDTHH:mm:ssZ');
            this.event.end = this.event.endDateTime.format('YYYY-MM-DDTHH:mm:ssZ');
            this.setDependantFields(this.event);
        }
        else {
            debug('Unrecognized type', 'Event type error');
        }
        console.log(this.event);
    }
    setDependantFields(event) {
        if (event.type === 'vacation') {
            event.recurrence = 'none';
            event.availableSessionType = null;
            this.createTodayList(event);
        }
        event.startTime = event.recurrence && event.recurrence !== 'none' ? event.startDateTime.format('HH:mm') : null;
        event.endTime = event.recurrence && event.recurrence !== 'none' ? event.endDateTime.format('HH:mm') : null;
        event.nonRecurringEventStart = moment('01-01-2000').add(event.startDateTime.hours(), 'hours').add(event.startDateTime.minutes(), 'minutes');
        event.nonRecurringEventEnd = moment('01-01-2000').add(event.endDateTime.hours(), 'hours').add(event.endDateTime.minutes(), 'minutes');
        event.daysOfWeek = event.recurrence && event.recurrence === 'weekly' ? [parseInt(event.startDateTime.format('E'), 10) % 7] : null;
        event.weekDay = parseInt(event.startDateTime.format('E'), 10) % 7;
        event.title = event.recurrence && event.recurrence !== 'none' ? event.recurrence : '';
    }
    createTodayList(event) {
        let today = event.startDateTime.format('YYYY-MM-DD');
        this.todayList = this.eventList.filter(item => item.startDateTime.format('YYYY-MM-DD') === today);
    }
    openLimitModal() {
        this.limitModalReference = this.modalService.open(this.limitModal, this.eventModalOptions);
        this.limitModalReference.result.then();
    }
    openEventModal() {
        this.eventModalReference = this.modalService.open(this.eventModal, this.eventModalOptions);
        this.eventModalReference.result.then();
    }
    openAlertModal(message) {
        const modalRef = this.modalService.open(AlertModalComponent, this.modalOptions);
        modalRef.componentInstance.alertModalRef = modalRef;
        modalRef.componentInstance.language = this.languageService.getCurrentLanguage();
        modalRef.componentInstance.userAlertMessage = message;
    }
    onCalendarEventChange() {
        if (!this.event.type) {
            this.openAlertModal('password.messages.typeRequired');
            return;
        }
        if (this.event.type === 'available' && !this.event.availableSessionType) {
            this.openAlertModal('password.messages.sessionTypeRequired');
            return;
        }
        if (!this.event.startDateTime) {
            this.openAlertModal('password.messages.startRequired');
            return;
        }
        if (!this.event.endDateTime) {
            this.openAlertModal('password.messages.endRequired');
            return;
        }
        if (!this.event.startDateTime.isBefore(this.event.endDateTime)) {
            this.openAlertModal('password.messages.startBefore');
            return;
        }
        if (this.event.type === 'available' && this.event.startDateTime.toDate().getDay() !== this.event.endDateTime.toDate().getDay()) {
            this.openAlertModal('password.messages.startEndSameDay');
            return;
        }
        // Available slots cannot be shorter than 1 hour (60 minute)
        if (this.event.type === 'available' && this.event.endDateTime.diff(this.event.startDateTime, "minute") < 60) {
            this.openAlertModal('password.messages.slotIsTooShort');
            return;
        }
        if (this.event.type === 'available' && !this.event.recurrence) {
            this.openAlertModal('password.messages.recurrenceRequired');
            return;
        }
        this.event.coachId = this.coachId;
        this.setDependantFields(this.event);
        this.filledCheckDone = true;
        // let checkList;
        if (this.event.type === 'available') {
            // if (this.event.recurrence === 'weekly') {
            //   this.checkListInForLoop(this.eventList, this.event);
            // } else {
            //   if (this.event.recurrence === 'daily') {
            //     checkList = this.eventList;
            //   } else if (this.event.recurrence === 'none') {
            //     checkList = this.eventList.filter(item => item.startDateTime.format('YYYY-MM-DD') === this.event.startDateTime.format('YYYY-MM-DD'));
            //   }
            //   this.checkListInForLoop(checkList, this.event);
            // }
            if (this.filledCheckDone) {
                this.createTodayList(this.event);
                this.eventActions(this.event);
            }
        }
        else if (this.event.type === 'vacation') {
            this.checkListInForLoop(this.eventList, this.event);
            if (this.filledCheckDone)
                this.eventActions(this.event);
        }
    }
    eventActions(event) {
        if (event.id) {
            this.updateEvent();
        }
        else {
            this.createEvent();
        }
    }
    updateEvent() {
        this.calendarUpdateSubscription = this.coachSlotService.update(this.event).subscribe(response => {
            if (response.status === 200) {
                this.renderCalendar(this.coachId);
                if (this.eventModalReference) {
                    this.eventModalReference.close('modal closed');
                }
                if (this.limitModalReference) {
                    this.limitModalReference.close('modal closed');
                }
                setTimeout(() => {
                    this.openAlertModal('password.messages.eventUpdated');
                }, 500);
            }
        }, (errorResponse) => {
            console.log(errorResponse);
        });
    }
    createEvent() {
        this.calendarCreateSubscription = this.coachSlotService.create(this.event).subscribe(response => {
            if (response.status === 201) {
                this.renderCalendar(this.coachId);
                if (this.eventModalReference) {
                    this.eventModalReference.close('modal closed');
                }
                if (this.limitModalReference) {
                    this.limitModalReference.close('modal closed');
                }
                setTimeout(() => {
                    this.openAlertModal('password.messages.eventCreated');
                }, 500);
            }
        }, (errorResponse) => {
            console.log(errorResponse);
        });
    }
    checkListInForLoop(list, event) {
        let start = event.recurrence === 'daily' ? event.nonRecurringEventStart : event.startDateTime;
        let end = event.recurrence === 'daily' ? event.nonRecurringEventEnd : event.endDateTime;
        for (let i = 0; i < list.length; i++) {
            if (event.id !== list[i].id && list[i].type === event.type) {
                let itemStart;
                let itemEnd;
                if (event.recurrence === 'weekly') {
                    if (list[i].recurrence === 'none') {
                        if (list[i].weekDay === event.weekDay) {
                            itemStart = moment(event.startDateTime.format('YYYY-MM-DD'))
                                .add(list[i].startDateTime.hours(), 'hours').add(list[i].startDateTime.minutes(), 'minutes');
                            itemEnd = moment(event.endDateTime.format('YYYY-MM-DD'))
                                .add(list[i].endDateTime.hours(), 'hours').add(list[i].endDateTime.minutes(), 'minutes');
                        }
                    }
                }
                else {
                    itemStart = this.createNonRecurringDate(list[i].startDateTime);
                    itemEnd = this.createNonRecurringDate(list[i].endDateTime);
                }
                if (itemStart != null && itemEnd != null) {
                    if (!(itemStart.isBefore(start).valueOf() && !itemEnd.isAfter(start).valueOf()) &&
                        !(!itemStart.isBefore(end).valueOf() && itemEnd.isAfter(end).valueOf())) {
                        console.log("Already occupied, start: " + itemStart + ", end: " + itemEnd + ", id: " + list[i].id);
                        this.filledCheckDone = false;
                        this.openAlertModal('password.messages.alreadyOccupied');
                        break;
                    }
                }
            }
        }
    }
    createNonRecurringDate(date) {
        let moment1 = moment('01-01-2000', 'DD-MM-YYYY');
        console.log("createNonRecurringDate: Calculated date: " + moment1);
        return moment1.add(date.hours(), 'hours').add(date.minutes(), 'minutes');
    }
    onMatDateTimePickerChange(event) {
        let dateTimeMoment = moment(event.value);
        if (event.targetElement.name === 'start') {
            this.startFormControl = new FormControl(dateTimeMoment.toDate());
            this.event.start = dateTimeMoment.format('YYYY-MM-DDTHH:mm:ssZ');
            this.event.startDateTime = moment(this.event.start);
        }
        else if (event.targetElement.name === 'end') {
            this.endFormControl = new FormControl(dateTimeMoment.toDate());
            this.event.end = dateTimeMoment.format('YYYY-MM-DDTHH:mm:ssZ');
            this.event.endDateTime = moment(this.event.end);
        }
    }
    onMatDateTimePickerToggleClick() {
        setTimeout(() => {
            document.querySelector('input[formcontrolname="minute"]').setAttribute('readonly', 'true');
            document.querySelector('input[formcontrolname="hour"]').setAttribute('readonly', 'true');
        }, 500);
    }
    onMatDateTimeFrequencyPickerChange(event) {
    }
    onMatDateTimeFrequencyPickerToggleClick() {
    }
    openMyCapacity() {
        const modalRef = this.modalService.open(PlanYourCapacityComponent);
        modalRef.componentInstance.myAvailabilityPreference = this.myAvailabilityPreference;
        modalRef.componentInstance.coach = this.coach;
    }
    onSubmitAvailabilityPreference() {
        this.myAvailabilityPreference.frequencyLastUpdated = moment();
        this.myAvailabilityPreference.startDate = moment(this.frequencyStartDate.value);
        this.myAvailabilityPreference.endDate = moment(this.frequencyEndDate.value);
        if (!this.myAvailabilityPreference.startDate.isBefore(this.myAvailabilityPreference.endDate)) {
            this.openAlertModal('password.messages.startBefore');
            return;
        }
        let d = this.myAvailabilityPreference.startDate.clone().add(3, "month");
        if (d.isBefore(this.myAvailabilityPreference.endDate)) {
            this.openAlertModal('password.messages.3month');
            return;
        }
        console.log(this.myAvailabilityPreference);
        if (this.myAvailabilityPreference.id != null) {
            this.saveMyAvailabilityPreferenceSubscription = this.coachAvailabilityPreferenceService.update(this.myAvailabilityPreference).subscribe(response => {
                console.log(response);
                this.openAlertModal('password.messages.preferenceUpdated');
            }, error => {
                console.log(error);
            });
        }
        else {
            this.myAvailabilityPreference.coach = new User();
            this.myAvailabilityPreference.coach.id = this.coach.coachId;
            this.saveMyAvailabilityPreferenceSubscription = this.coachAvailabilityPreferenceService.create(this.myAvailabilityPreference).subscribe(response => {
                console.log(response);
                this.openAlertModal('password.messages.preferenceCreated');
            }, error => {
                console.log(error);
            });
        }
    }
    deleteEvent(id) {
        this.calendarDeleteSubscription = this.coachSlotService.delete(parseInt(id, 10)).subscribe(response => {
            if (response.status === 204) {
                this.renderCalendar(this.coachId);
                if (this.eventModalReference) {
                    this.eventModalReference.close('modal closed');
                }
                if (this.limitModalReference) {
                    this.limitModalReference.close('modal closed');
                }
                setTimeout(() => {
                    this.openAlertModal('password.messages.eventDeleted');
                }, 500);
            }
        }, (errorResponse) => {
            console.log(errorResponse);
        });
    }
    onDailySessionLimitChange() {
        if (!(this.onlyPositiveNumbers.test(String(this.dailyLimit))) || String(this.dailyLimit).includes('00')) {
            this.openAlertModal('register.messages.error.numberOnlyLimit');
            return;
        }
        this.event.coachId = this.coachId;
        this.event.recurrence = 'none';
        this.event.type = 'limit';
        this.event.limitValue = this.dailyLimit;
        console.log(this.event);
        this.eventActions(this.event);
    }
    onResize() {
        let currentWidth = document.documentElement.clientWidth;
        this.windowHeight = document.documentElement.clientHeight;
        if ((this.windowWidth >= this.thresholdWidth && currentWidth < this.thresholdWidth) ||
            ((this.windowWidth < this.thresholdWidth && currentWidth >= this.thresholdWidth))) {
            this.responsiveTitleFormat = document.documentElement.clientWidth < this.thresholdWidth
                ? { month: 'short', day: 'numeric' }
                : { year: 'numeric', month: 'short', day: 'numeric' };
            this.renderCalendar(this.coachId);
        }
        this.windowWidth = currentWidth;
    }
    onStartDatePickerChange(event) {
        if (this.dateCheck(event.value, this.endDate.toDate())) {
            this.startFormControl = new FormControl(event.value);
            this.startDate = moment(event.value);
        }
        else {
            this.startFormControl = new FormControl(this.startDate.toDate());
        }
    }
    onEndDatePickerChange(event) {
        if (this.dateCheck(this.startDate.toDate(), event.value)) {
            this.endFormControl = new FormControl(event.value);
            this.endDate = moment(event.value);
        }
        else {
            this.endFormControl = new FormControl(this.endDate.toDate());
        }
    }
    dateCheck(start, end) {
        if (start >= end) {
            this.openAlertModal('inukaNgApp.coachStatistics.startBeforeEnd');
            return false;
        }
        else {
            return true;
        }
    }
    ngOnDestroy() {
        if (this.updateCoachDetailsSubscription)
            this.updateCoachDetailsSubscription.unsubscribe();
        if (this.calendarCreateSubscription)
            this.calendarCreateSubscription.unsubscribe();
        if (this.calendarUpdateSubscription)
            this.calendarUpdateSubscription.unsubscribe();
        if (this.calendarDeleteSubscription)
            this.calendarDeleteSubscription.unsubscribe();
    }
}
MyAvailabilityComponent.ɵfac = function MyAvailabilityComponent_Factory(t) { return new (t || MyAvailabilityComponent)(i0.ɵɵdirectiveInject(i1.UserService), i0.ɵɵdirectiveInject(i2.CoachSlotService), i0.ɵɵdirectiveInject(i3.CoachDetailsService), i0.ɵɵdirectiveInject(i4.JhiLanguageService), i0.ɵɵdirectiveInject(i5.PasswordResetInitService), i0.ɵɵdirectiveInject(i6.FormBuilder), i0.ɵɵdirectiveInject(i7.LoginService), i0.ɵɵdirectiveInject(i8.NgbModal), i0.ɵɵdirectiveInject(i9.AccountService), i0.ɵɵdirectiveInject(i10.JhiEventManager), i0.ɵɵdirectiveInject(i11.CoachAvailabilityPreferenceService)); };
MyAvailabilityComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MyAvailabilityComponent, selectors: [["my-availability"]], viewQuery: function MyAvailabilityComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fullCalendarComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.eventModal = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.limitModal = _t.first);
    } }, decls: 47, vars: 14, consts: [[1, "olha-theme", 3, "resize"], [1, "container"], [1, "card", "card-top"], ["jhiTranslate", "settings.setupNewClients", 1, "mb-2"], ["jhiTranslate", "settings.howMany", 1, "mb-2", 2, "color", "#8A9D98", "font-size", "16px"], ["name", "availabilityPreferenceForm", "role", "form", 3, "formGroup", "ngSubmit"], [1, "d-flex", "justify-content-between", "upper-div"], [1, "d-flex", "justify-content-between", "lower-div"], ["appearance", "outline", 1, "frequency-form-field"], ["jhiTranslate", "settings.clientNumber"], ["type", "number", "matInput", "", "formControlName", "newClientsNumber", 3, "ngModel", "placeholder", "ngModelChange"], ["jhiTranslate", "settings.frequency"], ["tabindex", "-1", "formControlName", "newClientsInterval", 3, "ngModel", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], ["jhiTranslate", "password.labels.selectStart"], ["matInput", "", "id", "start-frequency", "name", "startFrequency", "required", "", 3, "formControl", "matDatepicker", "dateInput"], ["matSuffix", "", 3, "for"], [3, "opened"], ["startFrequencyPicker", ""], ["jhiTranslate", "password.labels.selectEnd"], ["matInput", "", "id", "end-frequency", "name", "endFrequency", "required", "", 3, "formControl", "matDatepicker", "dateInput"], ["endFrequencyPicker", ""], [1, "alert-box-actions", 2, "text-align", "center"], ["type", "submit", "jhiTranslate", "password.buttons.submit", 1, "btn", "btn-gradient-primary", "font-weight-bold", "rounded-button"], ["jhiTranslate", "settings.capacity", 2, "font-size", "16px", "color", "#44A38B", "text-decoration", "underline", "font-weight", "bold", 3, "click"], [1, "card"], [1, "d-none", "d-md-block"], [1, "d-flex", "justify-content-between", "header"], [1, "align-items-center", 2, "margin-top", "30px"], ["jhiTranslate", "settings.setup", 1, "set-up-availability"], [1, "d-md-none"], [1, "header", "d-md-none"], [4, "ngIf"], ["eventModal", ""], ["limitModal", ""], [3, "value"], [3, "jhiTranslate"], [1, "card-body"], [1, "d-none", "d-md-block", 3, "options"], [1, "d-md-none", 3, "options"], [1, "modal-body"], [3, "ngSubmit"], [1, "form-group"], [1, "input-group"], [1, "input-group-prepend"], ["for", "type", "jhiTranslate", "password.labels.type", 1, "input-group-text", "form-label"], ["jhiTranslate", "password.labels.selectType"], ["id", "type", "tabindex", "-1", 3, "value", "valueChange"], ["class", "input-group", 4, "ngIf"], ["for", "start", "jhiTranslate", "password.labels.start", 1, "input-group-text", "form-label"], ["matInput", "", "id", "start", "name", "start", "required", "", "readonly", "", 3, "formControl", "ngxMatDatetimePicker", "dateInput"], ["startElement", ""], [3, "stepMinute", "opened"], ["startPicker", ""], ["for", "end", "jhiTranslate", "password.labels.end", 1, "input-group-text", "form-label"], ["matInput", "", "id", "end", "name", "end", "required", "", "readonly", "", 3, "formControl", "ngxMatDatetimePicker", "dateInput"], ["endPicker", ""], ["type", "button", "jhiTranslate", "password.buttons.cancel", 1, "btn", "btn-dark", "rounded-button", 3, "click"], ["type", "button", "class", "btn btn-dark rounded-button", "jhiTranslate", "password.buttons.delete", 3, "click", 4, "ngIf"], ["for", "availableSessionType", "jhiTranslate", "password.labels.sessionType", 1, "input-group-text", "form-label"], ["jhiTranslate", "password.labels.selectSessionType"], ["id", "availableSessionType", "tabindex", "-1", 3, "value", "valueChange"], ["for", "recurrence", "jhiTranslate", "password.labels.recurrence", 1, "input-group-text", "form-label"], ["jhiTranslate", "password.labels.selectRecurrence"], ["id", "recurrence", 3, "value", "valueChange"], ["type", "button", "jhiTranslate", "password.buttons.delete", 1, "btn", "btn-dark", "rounded-button", 3, "click"], ["for", "limitValue", "jhiTranslate", "password.labels.limit", 1, "input-group-text", "form-label"], ["jhiTranslate", "password.labels.selectLimit"], ["type", "number", "matInput", "", "id", "limitValue", "name", "limitValue", 3, "formControl", "ngModel", "ngModelChange"]], template: function MyAvailabilityComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("resize", function MyAvailabilityComponent_Template_div_resize_0_listener() { return ctx.onResize(); }, false, i0.ɵɵresolveWindow);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelement(3, "h2", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementStart(5, "form", 5);
        i0.ɵɵlistener("ngSubmit", function MyAvailabilityComponent_Template_form_ngSubmit_5_listener() { return ctx.onSubmitAvailabilityPreference(); });
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelementStart(8, "mat-form-field", 8);
        i0.ɵɵelement(9, "mat-label", 9);
        i0.ɵɵelementStart(10, "input", 10);
        i0.ɵɵlistener("ngModelChange", function MyAvailabilityComponent_Template_input_ngModelChange_10_listener($event) { return ctx.myAvailabilityPreference.newClientsNumber = $event; });
        i0.ɵɵpipe(11, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "mat-form-field", 8);
        i0.ɵɵelement(13, "mat-label", 11);
        i0.ɵɵelementStart(14, "mat-select", 12);
        i0.ɵɵlistener("ngModelChange", function MyAvailabilityComponent_Template_mat_select_ngModelChange_14_listener($event) { return ctx.myAvailabilityPreference.newClientsInterval = $event; });
        i0.ɵɵtemplate(15, MyAvailabilityComponent_mat_option_15_Template, 2, 2, "mat-option", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(16, "div", 7);
        i0.ɵɵelementStart(17, "mat-form-field", 8);
        i0.ɵɵelement(18, "mat-label", 14);
        i0.ɵɵelementStart(19, "input", 15);
        i0.ɵɵlistener("dateInput", function MyAvailabilityComponent_Template_input_dateInput_19_listener($event) { return ctx.onMatDateTimeFrequencyPickerChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(20, "mat-datepicker-toggle", 16);
        i0.ɵɵelementStart(21, "mat-datepicker", 17, 18);
        i0.ɵɵlistener("opened", function MyAvailabilityComponent_Template_mat_datepicker_opened_21_listener() { return ctx.onMatDateTimeFrequencyPickerToggleClick(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "mat-form-field", 8);
        i0.ɵɵelementStart(24, "mat-label", 19);
        i0.ɵɵtext(25, "e");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "input", 20);
        i0.ɵɵlistener("dateInput", function MyAvailabilityComponent_Template_input_dateInput_26_listener($event) { return ctx.onMatDateTimeFrequencyPickerChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(27, "mat-datepicker-toggle", 16);
        i0.ɵɵelementStart(28, "mat-datepicker", 17, 21);
        i0.ɵɵlistener("opened", function MyAvailabilityComponent_Template_mat_datepicker_opened_28_listener() { return ctx.onMatDateTimeFrequencyPickerToggleClick(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(30, "div", 22);
        i0.ɵɵelement(31, "button", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "a", 24);
        i0.ɵɵlistener("click", function MyAvailabilityComponent_Template_a_click_32_listener() { return ctx.openMyCapacity(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(33, "div", 25);
        i0.ɵɵelementStart(34, "div", 26);
        i0.ɵɵelementStart(35, "div", 27);
        i0.ɵɵelementStart(36, "div", 28);
        i0.ɵɵelement(37, "h3", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 30);
        i0.ɵɵelementStart(39, "div", 31);
        i0.ɵɵelementStart(40, "div", 28);
        i0.ɵɵelement(41, "h3", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(42, MyAvailabilityComponent_div_42_Template, 4, 2, "div", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(43, MyAvailabilityComponent_ng_template_43_Template, 41, 13, "ng-template", null, 33, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(45, MyAvailabilityComponent_ng_template_45_Template, 15, 3, "ng-template", null, 34, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = i0.ɵɵreference(22);
        const _r2 = i0.ɵɵreference(29);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("formGroup", ctx.availabilityPreferenceForm);
        i0.ɵɵadvance(5);
        i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(11, 12, "settings.clientNumber"));
        i0.ɵɵproperty("ngModel", ctx.myAvailabilityPreference.newClientsNumber);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngModel", ctx.myAvailabilityPreference.newClientsInterval);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.newClientsInterval);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("formControl", ctx.frequencyStartDate)("matDatepicker", _r1);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", _r1);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("formControl", ctx.frequencyEndDate)("matDatepicker", _r2);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("for", _r2);
        i0.ɵɵadvance(15);
        i0.ɵɵproperty("ngIf", ctx.webCalendarOptions || ctx.mobileCalendarOptions);
    } }, directives: [i12.JhiTranslateDirective, i6.ɵNgNoValidate, i6.NgControlStatusGroup, i6.FormGroupDirective, i13.MatFormField, i13.MatLabel, i6.NumberValueAccessor, i14.MatInput, i6.DefaultValueAccessor, i6.NgControlStatus, i6.FormControlName, i15.MatSelect, i16.NgForOf, i17.MatDatepickerInput, i6.RequiredValidator, i6.FormControlDirective, i17.MatDatepickerToggle, i13.MatSuffix, i17.MatDatepicker, i16.NgIf, i18.MatOption, i19.FullCalendarComponent, i6.NgForm, i20.NgxMatDatetimeInput, i20.NgxMatDatetimePicker], pipes: [i21.TranslatePipe], styles: [".olha-theme[_ngcontent-%COMP%]{background-color:#f7f4eb}.container[_ngcontent-%COMP%]{max-width:1500px !important}.card[_ngcontent-%COMP%]{margin:30px 0;width:100%}.card-top[_ngcontent-%COMP%]{padding:30px}.header[_ngcontent-%COMP%]{padding:0 30px 0 30px}.set-up-availability[_ngcontent-%COMP%]{color:#0a4a3a;font-family:\"Poppins\",sans-serif;font-style:normal;font-weight:700;font-size:25px;line-height:100%}.frequency-form-field[_ngcontent-%COMP%]{flex:1;padding:10px 10px 0 10px}.rounded-button[_ngcontent-%COMP%]{margin:8px;border-radius:40px;width:120px;padding-top:3px !important;padding-bottom:3px !important}div.card-body[_ngcontent-%COMP%]{padding-bottom:0 !important}label[_ngcontent-%COMP%]{opacity:.5;font-weight:bold}.col-12[_ngcontent-%COMP%]{padding-right:4px !important;padding-left:4px !important}.input-group-prepend[_ngcontent-%COMP%]{width:130px}.input-group-prepend[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{width:100%;overflow:hidden}.input-group-text[_ngcontent-%COMP%]{text-align:left;line-height:24px !important}.input-group-prepend[_ngcontent-%COMP%] > .input-group-text[_ngcontent-%COMP%]{border-right:1px solid #ced4da !important;border-top-right-radius:4px !important;border-bottom-right-radius:4px !important}.form-label[_ngcontent-%COMP%]{margin-right:.375rem !important}.accept-slide[_ngcontent-%COMP%]{margin-right:10px}.accept-text[_ngcontent-%COMP%]{font-family:\"Poppins\",sans-serif;font-style:normal;font-weight:600;font-size:18px;line-height:130%;text-align:center;color:#0a4a3a}[_nghost-%COMP%]     .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-bar{background:#44a38d}[_nghost-%COMP%]     .mat-slide-toggle.mat-checked:not(.mat-disabled) .mat-slide-toggle-thumb{background:#fff}[_nghost-%COMP%]     .mat-slide-toggle .mat-slide-toggle-bar{background-color:#e1e1e1}[_nghost-%COMP%]     .mat-slide-toggle .mat-slide-toggle-thumb{background-color:#fff}[_nghost-%COMP%]     .mat-radio-button, [_nghost-%COMP%]     .mat-form-field, [_nghost-%COMP%]     .mat-select{font-family:\"Open Sans\",sans-serif !important;font-size:16px !important}[_nghost-%COMP%]     .mat-radio-button.mat-accent .mat-radio-inner-circle, [_nghost-%COMP%]     .mat-radio-button.mat-accent .mat-radio-ripple .mat-ripple-element:not(.mat-radio-persistent-ripple), [_nghost-%COMP%]     .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-persistent-ripple, [_nghost-%COMP%]     .mat-radio-button.mat-accent:active .mat-radio-persistent-ripple{background-color:#44a38d}[_nghost-%COMP%]     .mat-radio-button.mat-accent.mat-radio-checked .mat-radio-outer-circle, [_nghost-%COMP%]     .mat-radio-outer-circle{border-color:#44a38d}[_nghost-%COMP%]     .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}[_nghost-%COMP%]     .mat-form-field-appearance-outline .mat-form-field-outline-thick{color:var(--main) !important}[_nghost-%COMP%]     .mat-form-field-flex{display:inline-flex;align-items:baseline;box-sizing:border-box;width:100%}[_nghost-%COMP%]  .mat-datepicker-content .mat-calendar{height:auto !important}.lower-div[_ngcontent-%COMP%]{flex:1}@media(min-width: 768px){.set-up-availability[_ngcontent-%COMP%]{font-size:30px;line-height:130%}.card[_ngcontent-%COMP%]{margin:50px 0}}@media(min-width: 992px){.set-up-availability[_ngcontent-%COMP%]{font-size:30px;line-height:130%}.card[_ngcontent-%COMP%]{margin:50px 0}}@media(max-width: 768px){.lower-div[_ngcontent-%COMP%]{flex-direction:column}}@media(max-width: 1200px){.upper-div[_ngcontent-%COMP%]{flex-direction:column}}"] });
